import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@environments';

@Pipe({
  name: 'assetFormatter',
})
export class AssetFormatterPipe implements PipeTransform {
  transform(value?: string): string {
    if (value === null || !value) {
      return '';
    }

    if (value.includes('http')) {
      return value;
    }

    return `${environment.assetsEndpoint}${value.startsWith('/') ? value : '/' + value}`;
  }
}
